import React, { useEffect, useState } from "react";
import RootLayout from "./root-layout";
import MainImage from "./MainImage";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { MdPassword } from "react-icons/md";

import axiosInstance from "../../apiInstances/axiosInstance";
import { toast } from "react-toastify";

import useEncryption from "../useEncryption/useEncryption";

const SignIn = () => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();

  // const { id } = useParams();
  const [loginFields, setLoginFields] = useState({
    email: "",
    password: "",
  });

  const onChangeInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setLoginFields({
      ...loginFields,
      [name]: value,
    });
  };

  const mydata = {
    email: loginFields?.email,
    password: loginFields?.password,
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const response = await axiosInstance.post("/login", loginFields);

  //     if (response?.data?.status) {
  //       navigate("/");
  //       toast.success(response.data.msg);
  //       console.log(response?.data)
  //       localStorage.setItem("Token", response?.data?.token);
  //       // localStorage.setItem("user", response?.data);
  //       localStorage.removeItem("email");
  //     } else {
  //       toast.error(response.data.msg);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("An error occurred. Please try again.");
  //   }
  // };

  const handleSubmit = async () => {
    await axiosInstance
      .post("login_admin", mydata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);

        console.log("=========myData", myData);

        if (myData?.status && myData?.data?.token) {
          localStorage.setItem("Token", myData?.data?.token);
          localStorage.setItem("Role", myData?.data?.userData?.role);
          toast.success(myData?.message);

          navigate("/");
          window.location.reload();
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // const Token = localStorage.getItem("Deatils");
  // const navigate = useNavigate();
  // const clickbutton = () => {
  //   if (Token === "deatils") {
  //     navigate("/templates");
  //   } else {
  //     navigate("/companydetails");
  //   }
  // };
  return (
    <>
      <RootLayout className="">
        <MainImage className="mt-8" />

        <div className="bg-white w-full max-w-xl rounded-3xl md:mt-16 mt-5 md:p-16 p-5 flex-center flex-col mb-4 ">
          <h1 className="text-regal-blue font-josefin font-bold text-4xl text-center text-[#22345C]">
            Login
          </h1>
          <div className="md:mt-24 mt-12">
            <div>
              <div className="relative mb-6 border w-full  rounded-lg ">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <HiOutlineMail size={25} className=" ml-2" />
                  </span>
                  <input
                    type="text"
                    id="input-group-1"
                    className="form-input-filed outline-none font-medium font-sans w-full py-2 px-2 rounded-lg"
                    placeholder="Enter email address"
                    name="email"
                    value={loginFields?.email}
                    onChange={onChangeInput}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className="relative mb-6 border w-full rounded-lg">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <MdPassword size={25} className=" ml-2" />
                  </span>
                  <input
                    type="password"
                    id="input-group-2"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="Enter Password"
                    name="password"
                    value={loginFields?.password}
                    onChange={onChangeInput}
                  />
                </div>
              </div>
            </div>

            <div className="flex gap-2 md:flex-row  justify-between items-center">
              <div className=" flex items-center gap-3">
                <input
                  type="checkbox"
                  id="input-group-3"
                  className="h-4 w-4 object-contain accent-regal-blue"
                />
                <h3 className="text-[#22345C] font-sans font-medium text-sm">
                  Remember me
                </h3>
              </div>
              <Link to="/forget">
                <h3 className="text-[#22345C] font-sans font-medium  text-sm">
                  Forget Password ?
                </h3>
              </Link>
            </div>
          </div>
          {/* to="/companydetails" */}
          <div className="justify-center items-center flex mt-8">
            {/*<Link to="/">*/}

            <button
              className="bg-[#22345C] rounded-lg py-3 px-8 font-medium text-lg text-white leading-normal "
              // onClick={() => clickbutton()}
              onClick={handleSubmit}
            >
              Login
            </button>

            {/*</Link>*/}
          </div>
          {/* <div className="mt-10 text-2xl font-medium font-josefin">
            <h4 className="text-[#A9A9A9]">
              Don't have an account ?&nbsp;
              <Link to="/sign-up">
                <span className="text-[#030239]">Sign Up</span>
              </Link>
            </h4>
          </div> */}
        </div>
      </RootLayout>
    </>
  );
};

export default SignIn;
